import WebSocket from 'isomorphic-ws/browser';
import { throttle } from 'Functions';

const WS_URL = process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8080/ws';

let WSService = null;

class WebSocketService {
    constructor() {
        this.websocket = null;
        this.messageListeners = [];
        this.isOpen = false;
        this.counterMessages = 0;
    }

    /**
     *  Set up WebSocket connection for a new user and
     *  basic listeners to handle events
     */
    initSocket = () => {
        this.websocket = new WebSocket(WS_URL);
        this.websocket.onopen = this.onConnOpen;
        this.websocket.onmessage = this.onMessage;
        this.websocket.onclose = this.onConnClose;
    };

    /**
     *  Show connection status to us in the log
     */
    onConnOpen = () => {
        this.isOpen = true;
        // console.log('Websocket connected!');
    };

    /**
     *  Log lost connection for now
     */
    onConnClose = () => {
        WSService.initSocket();
        // console.log('Websocket closed!');
    };

    /**
     *  Used by application to send message to the WebSocket API Gateway
     *  @param routeKey The route key for WebSocket API Gateway
     *  @param message String message
     *  message {
     *    room,
     *    type,
     *    msg,
     *    username,
     *    for
     *  }
     */
    sendMessage = (routeKey, message) => {
        // console.log(routeKey);
        // console.log(message);

        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
            this.websocket.send(
                JSON.stringify({
                    action: routeKey,
                    data: JSON.stringify(message),
                })
            );
        } else {
            //console.log(`Websocket connection not found!!`);
            WSService.initSocket();
            throttle(
                setTimeout(() => this.sendMessage(routeKey, message), 10000),
                30000
            );
            alert('Conexión perdida, vuelve a iniciar sesión');
        }
    };

    /**
     *  Used by application to register different listeners for
     *  different message types
     *  @param room Room name
     *  @param type Message type ['all', 'pm', 'userlist', 'useradd']
     *  @param listener Function to handle message type
     */
    addMessageListener = (room, type, listener) => {
        if (!type || !room || typeof listener !== 'function') {
            return;
        }
        const elementIndex = this.messageListeners.findIndex(
            e => e.type === type && e.room === room
        );
        if (elementIndex >= 0) {
            this.messageListeners.splice(elementIndex, 1);
        }
        this.messageListeners.push({
            room,
            type,
            listener,
        });
    };

    /**
     *  Used by application to remove listeners from the websocket
     *  @param room Room name
     *  @param type Message type ['all', 'pm', 'userlist', 'useradd']
     */
    removeMessageListener = (room, type) => {
        if (!type || !room) {
            return;
        }
        this.messageListeners = this.messageListeners.filter(
            listener => listener.room === room && listener.type === type
        );
    };

    /**
     * Handler that receives the actual messages from the WebSocket API
     * For now it simply returns the parsed message body to the appropriate
     * registered handler
     * @param data Message body received from WebSocket
     */
    onMessage = data => {
        if (data) {
            const message = JSON.parse(data.data);
            const typeListener = this.messageListeners.find(
                listener => listener.type === message.Type
            );

            if (typeListener && typeof typeListener.listener === 'function') {
                this.counterMessages += 1;
                typeListener.listener(message, this.counterMessages);
            } else {
                //console.log('No handler found for message type');
            }
        }
    };

    static initWSService() {
        if (!WSService) {
            WSService = new WebSocketService();
            WSService.initSocket();
        }

        return WSService;
    }
}

export const getWSService = WebSocketService.initWSService;
